import { default as BSCollapse } from 'bootstrap/js/src/collapse'

class Collapse extends BSCollapse {}

export default Collapse
